import React, { useState, useEffect } from 'react';
import ManagementLayout from '../layout/ManagementLayout';
import StatCard from './StatCard';
import LoadingState from '../common/LoadingState';
import ErrorState from '../common/ErrorState';
import useAuth from '../../auth/useAuth';
import { fetchDashboard } from '../../api/mediaApi';

export default function Dashboard() {
  const { customer } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetchDashboard();
      setData(res.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const stats = data?.stats;
  const cats = stats?.categories || {};

  return (
    <ManagementLayout>
      <div className="mol-page">
        <div className="mol-page__header">
          <div>
            <h2 className="mol-page__title">Dashboard</h2>
            <p className="mol-page__subtitle">
              {data?.customerName
                ? `Welcome back. Here\u2019s an overview for ${data.customerName}.`
                : 'Welcome back. Here\u2019s your media overview.'}
            </p>
          </div>
        </div>

        {loading ? (
          <LoadingState />
        ) : error ? (
          <ErrorState message={error} onRetry={load} />
        ) : stats ? (
          <>
            <div className="mol-stat-grid">
              <StatCard label="Total Files" value={stats.totalFiles} color="#00B4FE" icon={
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              } />
              <StatCard label="Storage Used" value={stats.totalSize} color="#0FB9C7" icon={
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></svg>
              } />
              <StatCard label="Folders" value={stats.folderCount} color="#6366F1" icon={
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>
              } />
            </div>

            <div className="mol-section">
              <h3 className="mol-section__title">By Category</h3>
              <div className="mol-stat-grid">
                <StatCard label="Videos" value={cats.videos?.count ?? 0} color="#6366F1" icon={
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="2.18"/><line x1="7" y1="2" x2="7" y2="22"/><line x1="17" y1="2" x2="17" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/></svg>
                } />
                <StatCard label="Curated Content" value={cats['curated-content']?.count ?? 0} color="#F59E0B" icon={
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                } />
                <StatCard label="Photos" value={cats.photos?.count ?? 0} color="#10B981" icon={
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                } />
                {(cats.uncategorized?.count ?? 0) > 0 && (
                  <StatCard label="Uncategorized" value={cats.uncategorized.count} color="#8B5CF6" icon={
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  } />
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </ManagementLayout>
  );
}
